import Box2 from '@/assets/images/Box2.svg';
import Logout from '@/assets/images/Logout.svg';
import OpenBoxIcon from '@/assets/images/OpenBook.svg';
import SnapIconNotFilled from '@/assets/images/SnapIconNotFilled.svg';
import IconWand from '@/components/icons/IconWand';
import {
  headerTitle,
  homeStyles,
  imgStyles,
  linkStyles,
  linkTextStyles,
  navigationStyles,
  nestedLinkStyles,
  sectionLabelStyles,
  sidebarContainerStyles,
  userImgStyles,
} from '@/components/Index/SidebarStyles';
import { getLocationItemUrl, UrlProps } from '@/pages/LocationItemManager';
import { useAuth0 } from '@auth0/auth0-react';
import { Link, useParams } from 'react-router-dom';
import { Box, Button, Flex, Heading, Image, Text } from 'theme-ui';
import {
  useCategoryBanners,
  useIsItemBrandAssociationEnabled,
  useItemIssues,
  useSelfServiceMarketingCollections,
} from '../hooks/featureflipper';

const Sidebar = () => {
  const { logout } = useAuth0();
  const { id } = useParams<UrlProps>();
  const isItemBrandAssociationEnabled = useIsItemBrandAssociationEnabled();
  const isSelfServiceMarketingCollectionsEnabled =
    useSelfServiceMarketingCollections();
  const isItemIssuesEnabled = useItemIssues();
  const isCategoryBannersEnabled = useCategoryBanners();
  const locationItemManagerUrl = getLocationItemUrl(id);
  return (
    <Flex className="sidebar" sx={sidebarContainerStyles}>
      <Box sx={navigationStyles}>
        <Heading sx={{ ...headerTitle, variant: 'text.headingXs' }}>
          <Image src={SnapIconNotFilled} sx={userImgStyles} alt="" />
          <Text className="title" sx={linkTextStyles}>
            Item Management
          </Text>
        </Heading>
        <Link to="/" sx={linkStyles}>
          <Image src={Box2} sx={imgStyles} />
          <Text className="title" sx={linkTextStyles}>
            Items List
          </Text>
        </Link>
        <Link to="/base_branded_items" sx={linkStyles}>
          <Image src={Box2} sx={imgStyles} />
          <Text className="title" sx={linkTextStyles}>
            Base Branded Items List
          </Text>
        </Link>
        <Link to={locationItemManagerUrl} sx={linkStyles}>
          <Image src={Box2} sx={imgStyles} />
          <Text className="title" sx={linkTextStyles}>
            Location Item Manager
          </Text>
        </Link>
        {isItemBrandAssociationEnabled && (
          <Link to="/brands" sx={linkStyles}>
            <Image src={Box2} sx={imgStyles} />
            <Text className="title" sx={linkTextStyles}>
              Brand Manager
            </Text>
          </Link>
        )}
        {isSelfServiceMarketingCollectionsEnabled && (
          <>
            {isCategoryBannersEnabled && (
              <Text sx={sectionLabelStyles}>Marketing</Text>
            )}
            <Link
              to="/collections"
              sx={isCategoryBannersEnabled ? nestedLinkStyles : linkStyles}
            >
              <Image src={OpenBoxIcon} sx={imgStyles} />
              <Text className="title" sx={linkTextStyles}>
                Collections
              </Text>
            </Link>
            {isCategoryBannersEnabled && (
              <Link to="/categories" sx={nestedLinkStyles}>
                <Image src={OpenBoxIcon} sx={imgStyles} />
                <Text className="title" sx={linkTextStyles}>
                  Categories
                </Text>
              </Link>
            )}
          </>
        )}
      </Box>
      <Box sx={homeStyles}>
        {isItemIssuesEnabled && (
          <Link
            to="/item-issues"
            sx={{
              ...linkStyles,
              '&:hover': { backgroundColor: '#FAF5FF' },
            }}
          >
            <Box
              sx={{
                ...imgStyles,
                display: 'inline-flex',
                p: '2px',
                ml: 3,
                color: '#8200DB',
              }}
            >
              <IconWand size={20} />
            </Box>
            <Text
              className="title"
              sx={{ ...linkTextStyles, color: '#8200DB' }}
            >
              Item Issues
            </Text>
          </Link>
        )}
        <Button
          onClick={() =>
            logout({ logoutParams: { returnTo: window.location.origin } })
          }
          sx={{
            ...linkStyles,
            bg: 'neutralLight',
            padding: '0',
            textAlign: 'left',
          }}
        >
          <Image src={Logout} sx={imgStyles} />
          <Text className="title" sx={linkTextStyles}>
            Log Out
          </Text>
        </Button>
      </Box>
    </Flex>
  );
};

export default Sidebar;
